<template>
  <div class="content">
    <div class="icon">
      <img src="https://picture.eclicks.cn/kaojiazhao/public/rem/ecSale/icon_order_pay.png" alt="">
      <div class="type">已为您生成预订订单，请及时支付</div>
      <div class="order-no">单号：{{payOrder.order_no}}</div>
    </div>
    <div class="button">
      <button class="btn" @click="pay">去支付<i v-if="paying" class="weui-loading" style="width: 25px;height: 25px;margin-left: .1rem;"></i></button>
      <div class="count-count">支付倒计时：<span>{{down.value}}</span></div>
    </div>
    <div class="button-list">
      <div class="btn-item" @click="cancel">取消订单</div>
      <div class="btn-item btn-return" @click="returnIndex">返回首页</div>
    </div>
    <div class="footer">
      <div class="hint-1" style="color:#1460FD">支付成功后8个工作日内发货</div>
      <div class="hint-2">如有疑问请联系客服热线：13127832213</div>
      <div class="hint-1">（周一～周五 9:00～18:00）</div>
    </div>
  </div>
</template>
<script>
import { payUrl, hostUrl } from '../http/env.js'
import { ecSaleCancelOrder, getOrderByNo } from '@/http/api'
import axios from 'axios'
import 'weui'
import weui from 'weui.js'
import _kjz from '../../static/js/chelun-kjz.js'
import _jl from '../../static/js/chaojijiaolian-jl.js'
import URL from '../../static/js/url.js'
import secondsFormat from '../util/secondsFormat'
export default {
  props: ['payOrder', 'openid', 'isApp'],
  data () {
    return {
      paying: false,
      public_path: process.env.PUBLICK_PATH,
      pay_order: this.payOrder,
      open_id: this.openid,
      isapp: URL.getQueryString('isapp') || '',
      count_down: 600,
      os: URL.getQueryString('os') || '',
      down: {
        value: '00:10:00',
        type: 'time'
      }
    }
  },
  methods: {
    getOrderByNo () {
      getOrderByNo({
        type: 1,
        order_no: this.payOrder.order_no
      }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.count_down = res.data.count_down
          this.computeTime()
          setInterval(this.computeTime, 1000)
        }
      })
    },
    pay () {
      if (this.paying) {
        return
      } else {
        this.paying = true
        let channel = this.channel ? this.channel : _wx.isWx ? 'weixin_mp' : 'alipay'
        let callbackUrl = `${hostUrl}/frontend/ec-sale-successed?os=${this.os}`
        console.log(this.isapp)
        if (_jl.isApp) {
          let param = {
            orderNum: this.payOrder.serial_number,
            channels: 'weixin,alipay',
            price: (this.payOrder.amount).toFixed(2),
            callbackUrl: callbackUrl
          }
          _kjz.appPay(param)
          setTimeout(() => {
            this.paying = false
          }, 2000)
        } else {
          let url = `${payUrl}/api.php?c=order&v=pay2&serial_number=${this.payOrder.serial_number}&channel=${this.payOrder.channels}&openid=${this.openid}&callback_url=${callbackUrl}`
          axios.get(url).then(res => {
            this.paying = false
            if (_wx.isWx) {
              _wx.pay(res.data.data.order_param, function () {
                window.location.href = res.data.data.order_param.callback_url
              })
            } else {
              window.location.href = res.data.data.url
            }
          })
        }
      }
    },
    cancel () {
      ecSaleCancelOrder({id: this.payOrder.id}).then(res => {
        console.log(res)
        if (res.code == 0) {
          localStorage.clear()
          window.location.href = `${hostUrl}/frontend/ec-sale-fail`
        }
      })
    },
    returnIndex () {
      window.location.href = `${hostUrl}/frontend/ec-sale`
    },
    computeTime () {
      this.count_down --
      let down = this.count_down
      if (down <= 0) {
        down = 0
        window.location.href = `${hostUrl}/frontend/ec-sale-fail`
      }
      this.down = secondsFormat(down)
    }
  },
  mounted () {
    this.getOrderByNo()
  }
}
</script>
<style lang="scss" scoped>
.content {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-top: .58rem;
  .icon {
    text-align: center;
    img {
      width: 1.96rem;
      height: auto;
    }
    .type {
      text-align: center;
      font-size: .40rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
    }
    .order-no {
      margin-top: .32rem;
      font-size: .30rem;
      color: rgba(0, 0, 0, .7);
    }
  }
  .button {
    margin-top: .42rem;
    text-align: center;
    .btn {
      width: 7.10rem;
      height: .90rem;
      background: url(https://picture.eclicks.cn/kaojiazhao/public/rem/ecSale/btn_blue.png) no-repeat;
      background-position: 0 0;
      background-size: 100% auto; 
      border-radius: .12rem;
      line-height: .9rem;
      color: #fff;
      font-weight: 600;
      font-size: .34rem;
    }
    .count-count {
      margin-top: .3rem;
      margin-right: .3rem;
      text-align: right;
      font-size: .26rem;
      color: #000;
      span {
        color: #F73A1E;
      }
    }
  }
  .button-list {
    width: 7.10rem;
    margin: auto;
    display: -webkit-flex;
    display: flex;
    margin-top: .6rem;
    .btn-item {
      font-size: .34rem;
      text-align: center;
      width: 3.45rem;
      height: .9rem;
      line-height: .9rem;
      font-weight: 500;
      color: #ccc;
      border: 1px solid #ccc;
      border-radius: .12rem;
    }
    .btn-return {
      margin-left: .2rem;
    }
  }
  .footer {
    padding-bottom: 1rem;
    margin-top: 2rem;
    text-align: center;
    .hint-img {
      width: 5.3rem;
    }
    .hint-1 {
      font-size: .26rem;
      line-height: .40rem;
      opacity: 0.7;
      margin-top: .2rem;
    }
    .hint-2 {
      margin-top: .72rem;
      font-size: .30rem;
      font-weight:400;
      // color: #1460FD;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ecSalePay.vue